/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";
import {SupplierFunctionId} from "./supplierFunctionId.zod";

export const SupplierFunctionRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.supplier-functions"]),
    resourceId: SupplierFunctionId,
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type SupplierFunctionRealtimeChange = zod.input<typeof SupplierFunctionRealtimeChange>;
export type SupplierFunctionRealtimeChangeOutput = zod.output<
  typeof SupplierFunctionRealtimeChange
>;
